var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bt-stop_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.107.793C1.971.905 1.073 1.726.824 2.881.782 3.075.78 3.466.78 12c0 8.535.002 8.925.044 9.119.232 1.076.981 1.826 2.057 2.057.194.042.585.044 9.119.044 8.535 0 8.925-.002 9.119-.044 1.076-.231 1.826-.981 2.057-2.057.042-.194.044-.584.044-9.119s-.002-8.925-.044-9.119c-.23-1.066-.95-1.795-2.032-2.056-.172-.042-.58-.044-9.012-.047C7.274.776 3.213.783 3.107.793m.135 2.017a.55.55 0 0 0-.434.455c-.016.088-.022 3.032-.018 8.82.005 7.9.01 8.695.044 8.771.06.13.157.231.28.292l.114.056h17.544l.114-.056a.6.6 0 0 0 .28-.292c.035-.077.038-.87.038-8.856V3.228l-.056-.113a.6.6 0 0 0-.292-.28c-.076-.036-.87-.04-8.796-.042-4.863-.002-8.759.005-8.818.017",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bt-stop_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgBtStop;